export const AnalyticsCategory = {
    pageLoad: "page-load",
    buttonClick: "button-click",
    rowSort: "row-sort",
    filter: "filter",
    optionSelect: "option-select",
    info: "info",
    search: "search",
};
